module.exports = __webpack_public_path__ + "media/admin/components/worker-plugins/model-checkbox/element-image-c836d91731d491e0cc7fe1f327d7bd8b.png";